module.exports = __webpack_public_path__ + "img/sea-2.87e23cf0.jpg";